const module = { name: 'movie/shared/mobile/snackbar', exports: {} }; const exports = module.exports;



const Styles = {
    FADE_IN: 'buy-tickets-snackbar--fade-in',
    FADE_OUT: 'buy-tickets-snackbar--fade-out',
}


const FADE_DURATION = 500
function toggle(id, show) {
    const snackbar = document.querySelector(id);
    if (!snackbar) {
        return;
    }
    if (show) {
        snackbar.style.visibility = 'visible';
        snackbar.classList.remove(Styles.FADE_OUT);
        snackbar.classList.add(Styles.FADE_IN);
    }
    else {
        snackbar.classList.remove(Styles.FADE_IN);
        snackbar.classList.add(Styles.FADE_OUT);
        setTimeout(() => snackbar.style.visibility = 'hidden', FADE_DURATION + 10);
    }
}
exports.attach = id => ({
    visible: false,
    show() {
        toggle(id, true);
        this.visible = true;
    },
    hide() {
        toggle(id, false);
        this.visible = false;
    }
});
export default module.exports;